import api from './api';

const groupsService = {
  // Customer Groups
  getCustomerGroups: () => api.get('/customergroups'),
  createCustomerGroup: (data: any) => api.post('/customergroups', data),
  updateCustomerGroup: (id: number, data: any) => api.put(`/customergroups/${id}`, data),
  deleteCustomerGroup: (id: number) => api.delete(`/customergroups/${id}`),

  // Supplier Groups
  getSupplierGroups: () => api.get('/suppliergroups'),
  createSupplierGroup: (data: any) => api.post('/suppliergroups', data),
  updateSupplierGroup: (id: number, data: any) => api.put(`/suppliergroups/${id}`, data),
  deleteSupplierGroup: (id: number) => api.delete(`/suppliergroups/${id}`),
};

export default groupsService;
